import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterEtapas() {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/etapas`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },
    obterEtapasFaturadasNaoQuitadas() {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/etapas/EtapasFaturadasNaoQuitadas`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },
    obterEtapasPorVencimentos() {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/etapas/vencimentos`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterProjeto(projetoId) {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/projetos/${projetoId}`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterUnidades() {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/dotacoes/unidades`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterProjetos(codUnidade) {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/dotacoes/unidades/${codUnidade}/projetos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAcoes(codUnidade, codProjeto) {
        return axiosJwt
            .get(
                `${api}/sgtec/financeiro/dotacoes/unidades/${codUnidade}/projetos/${codProjeto}/acoes`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDespesas(etapaId) {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/etapas/${etapaId}/despesas`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    atualizarCentroCusto(etapaId, despesaId, ccusto) {
        return axiosJwt
            .put(`${api}/sgtec/financeiro/etapas/${etapaId}/despesas/${despesaId}/atualizarcentrocusto`, ccusto)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    permiteAtualizarDespesa(etapaId) {
        return axiosJwt
            .put(`${api}/sgtec/financeiro/etapas/${etapaId}/despesas/permiteatualizardespesa`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    excluirComprometimento(etapaId, despesaId) {
        return axiosJwt
            .patch(`${api}/sgtec/financeiro/etapas/${etapaId}/despesas/${despesaId}/excluircomprometimento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterErroComprometimento(etapaId, despesaId) {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/etapas/${etapaId}/despesas/${despesaId}/errocomprometimento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
